import { initCustomCheckboxes, customFormsClickHandler } from '../common';
import { ModalTemplate } from '../modals/template';
import { ChangeLanguageModal } from '../modals/language';
import { BuyTicketsModal, BuyTicketsModalEmbedLayout, BuyTicketsModalEmbedLayoutProperties, BuyTicketsModalPaymentMethod } from '../modals/buy';
import { EmbedTicketsModal } from '../modals/embed';
import { ManageDiscountCodesModal } from '../discount/discount';
import { BillingInformationModal } from '../modals/billing_information';
import { ImportEventModal } from '../modals/import';
import { FeatureModal } from '../modals/featured';
import { FeaturedCampaignsReportModal } from '../modals/featured';
import { ShareModal } from '../modals/share';
import { HashHandler } from '../hash_handler';
import { DataSender } from '../loaders';

const loadGoogleMapsApi = require('load-google-maps-api')

/**
 * Profile
 */
class Profile {
    constructor(userId, settings={}) {
        var that = this;

        this.locked = false;
        this.texts = {};
        this.mine = 0;
        this.userId = 0;
        this.profileEventsOpened = false;
        this.profileHostsOpened = false;
        this.profileAchievementsOpened = false;
        this.allEventsLoaded = false;
        this.allHostsLoaded = false;
        this.allAchievementsLoaded = false;

        this.set(userId);

        this.userId = userId;
        this.texts = (typeof settings.texts == 'undefined') ? [] : settings.texts;
        this.mine = settings.mine;
        this.lastNameOnly = settings.lastNameOnly;

        this.initProfile();

        if (this.mine > 0) {
            this.initLocation($('#profile-current-city-autocomplete').get(0), 'current');
            this.initLocation($('#profile-home-city-autocomplete').get(0), 'home');
            $("#categories input").change(function() {
                that.updateCategory($(this).data("id"), $(this).attr("checked") ? true : false);
            });

            $('#add-tag-input').autocomplete({
                autoFocus: true,
                source: "/common/token-tags/",
                minLength: 2,
                select: function(event, ui) {
                    that.addTag(ui.item.id);
                }
            });
            this.initEditables();
        }

        // hash handler
        this.hashHandler = new HashHandler();

        this.hashHandler.addAction('#add-city', false, function() {
            if(that.mine > 0) {
                $('#edit-profile-modal').show();
                that.hashHandler.clearHash();
            }
        });

        this.hashHandler.addAction('#add-interests', false, function() {
            if(that.mine > 0) {
                window.setTimeout(function() {
                    $('html, body').animate({ scrollTop: $('#categories-wrapper').position().top }, 200);
                }, 250);
                that.hashHandler.clearHash();
            }
        });

        this.hashHandler.addAction('#friend', false, function() {
            if(!that.mine && $('section.panel a.friend').length) {
                that.hashHandler.clearHash();
                that.friend();
            }
        });

        this.hashHandler.addAction('#accept', false, function() {
            if(!that.mine && $('section.panel a.accept').length) {
                that.hashHandler.clearHash();
                that.friend();
            }
        });

        this.hashHandler.addAction('#decline', false, function() {
            if(!that.mine && $('section.panel a.decline').length) {
                that.hashHandler.clearHash();
                that.unfriend('decline');
            }
        });
    }

    _lock() {
        this.locked = true;
    }

    _unlock() {
        this.locked = false;
    }

    _changeFriend(userId, status, callback, msg) {
        var that = this;
        that._lock();

        if (msg == undefined || !msg) {
            msg = this.texts.areYouSureRemove;
        }

        if (status) {
            $.ajax({
                url: "/profile/change-friend/", dataType: 'json', type: 'post',
                data: {user_id: userId, status: '1'},
                success: function(data) {
                    if (data && data.success != undefined && data.success) {
                        callback(data);
                        that._unlock();
                    } else that._unlock();
                },
                error: function(e) {
                    console.log(e);
                }
            });
        } else {
            if(!window.confirm(msg)){
                that._unlock();
                return;
            }

            $.ajax({
                url: "/profile/change-friend/", dataType: 'json', type: 'post',
                data: {user_id: userId, status: '0'},
                success: function(data) {
                    if (data && data.success != undefined && data.success) {
                        callback(data);
                        that._unlock();
                    } else that._unlock();
                }
            });
        }
    }

    _removePicture() {
        if (this.locked) return;
        var that = this;
        this._lock();

        $.ajax({
            url: "/profile/remove-picture/",
            dataType: 'json',
            type: 'post',
            data: {
                id: that.userId
            },
            success: function(data) {
                if (data && data.status != undefined && data.status && data.picture != undefined) {
                    that._unlock();
                    that._changePicture(data.picture);
                }
                that._unlock();
            }
        });
    }

    _changePicture(picture) {
        $('section.panel form img').attr('src', picture);
        $('section.panel div.custom-browse a.remove').tooltip('hide').remove();
    }

    initLocation(input, parent) {
        if (input && window.googleApiPublicKey) {
            var that = this;
            loadGoogleMapsApi({'key': window.googleApiPublicKey, 'libraries': ['places']}).then(function (googleMaps) {
                var autocomplete = new googleMaps.places.Autocomplete(input, { types: ['(cities)'] }); //, { types: ['(cities)'] } , { types: ['establishment'] }

                googleMaps.event.addDomListener(input, 'blur', function(e) {
                    // clear data if empty
                    if($(input).val().length == 0){
                        $('input[name="' + parent + '-city-name"]').val('');
                        $('input[name="' + parent + '-country-code"]').val('');
                        $('input[name="' + parent + '-sublocality"]').val('');
                        $('input[name="' + parent + '-lat"]').val('');
                        $('input[name="' + parent + '-lng"]').val('');
                    }

                });

               googleMaps.event.addListener(autocomplete, 'place_changed', function() {
                   var place = autocomplete.getPlace();

                   if(place.geometry === undefined) return false;

                   $('input[name="' + parent + '-lat"]').val(place.geometry.location.lat());
                   $('input[name="' + parent + '-lng"]').val(place.geometry.location.lng());

                   var sublocality = '';
                   var city = '';
                   var country = '';

                   $.each(place.address_components, function(key, value) {
                       if ($.inArray("sublocality", value.types) >= 0) {
                           sublocality = value.long_name;
                           $('input[name="' + parent + '-sublocality"]').val(sublocality);
                       }
                       else if ($.inArray("locality", value.types) >= 0) {
                           city = value.long_name;
                           $('input[name="' + parent + '-city-name"]').val(city);
                       }
                       else if ($.inArray("country", value.types) >= 0) {
                           country = value.short_name;
                           $('input[name="' + parent + '-country-code"]').val(country);
                       }
                   });
                   if (sublocality == '')
                       $('input[name="' + parent + '-sublocality"]').val(sublocality);
                   if (city == '')
                       $('input[name="' + parent + '-city-name"]').val(city);
                   if (country == '')
                       $('input[name="' + parent + '-country-code"]').val(country);
               });
            }).catch(function (error) {
              console.error(error)
            })
        }
    }

    friend() {
        var that = this;

        this._changeFriend(that.userId, 1, function() {
           window.location.reload();
        });
    }

    unfriend(message) {
        var that = this;

        switch(message) {
            case 'cancel': message = that.texts.areYouSureCancel; break;
            case 'decline': message = that.texts.areYouSureDecline; break;
            default: message = that.texts.areYouSureRemove; break;
        }

        this._changeFriend(that.userId, 0, function() {
            window.location.reload();
        }, message);
    }

    save() {
        if (this.locked) return;
        var that = this;
        this._lock();

        var gender = $("#profile-gender-input").val();
        var homeCity = $("#profile-home-city-input").val();
        var homeCityName = $('input[name="home-city-name"]').val();
        var homeSublocality = $('input[name="home-sublocality"]').val();
        var homeCountryCode = $('input[name="home-country-code"]').val();
        var homeLat = $('input[name="home-lat"]').val();
        var homeLng = $('input[name="home-lng"]').val();
        var currentCity = $("#profile-current-city-input").val();
        var currentCityName = $('input[name="current-city-name"]').val();
        var currentSublocality = $('input[name="current-sublocality"]').val();
        var currentCountryCode = $('input[name="current-country-code"]').val();
        var currentLat = $('input[name="current-lat"]').val();
        var currentLng = $('input[name="current-lng"]').val();
        var day = parseInt($("#profile-birthday-day-input").val());
        var month = parseInt($("#profile-birthday-month-input").val());
        var year = parseInt($("#profile-birthday-year-input").val());
        var birthday = '';
        if (year && month && day) {
            if (day < 10) day = '0' + day;
            if (month < 10) month = '0' + month;
            birthday = year + '-' + month + '-' + day;
        }

        $('div.loader', '#edit-profile-modal', '#settingsModal').show();

        $.ajax({
            url: "/profile/save/", dataType: 'json', type: 'post',
            data: {
                gender: gender,
                birthday: birthday,
                home_city: homeCity,
                homeCityName: homeCityName,
                homeSublocality: homeSublocality,
                homeCountryCode: homeCountryCode,
                homeLat: homeLat,
                homeLng: homeLng,
                current_city: currentCity,
                currentCityName: currentCityName,
                currentSublocality: currentSublocality,
                currentCountryCode: currentCountryCode,
                currentLat: currentLat,
                currentLng: currentLng
            },
            success: function(data) {
                if (data.success != undefined && data.success) {
                    $("#profile-info").html(data.info);
                    that.updateMinimumHeight();
                }

                $('#settingsModal').hide();
                $("body").removeClass('modal-open');
                $("body").removeAttr("style");
                that._unlock();
            }, error: function(e) {
                console.log(e);
            }
        });
    }

    updateCategory(categoryId, status) {
        if (this.locked) return;
        var that = this;
        this._lock();

        $.ajax({
            url: "/profile/set-category/", dataType: 'json', type: 'post',
            data: {id: categoryId, status: status ? 1 : 0},
            success: function(data) {
                that._unlock();
            }
        });
    }

    addTag(tagId) {
        if (this.locked) return;
        var that = this;
        this._lock();

        $.ajax({
            url: "/profile/set-tag/", dataType: 'json', type: 'post',
            data: {id: tagId, status: 1},
            success: function(data) {
                if (data.success != undefined && data.success) {
                    $("form", "#tags-wrapper").removeClass("no-padding");
                    $("#tags").append('<li id="tag-' + data.id + '">' + data.name + ' <a href="#" onclick="window.profilePage.deleteTag(' + data.id + '); return false;"></a></li>');
                    if($("#setup-tags")){
                        $("#setup-tags").append('<li class="d-flex justify-content-between align-items-center p-2 m-1 rounded bg-white" id="tag-' + data.id + '">' + data.name + ' <a href="#" class="ms-2" onclick="window.profilePage.deleteTag(' + data.id + '); return false;"><img src="/img/svg/icon-close-search.svg" alt="Delete tag"/></a></li>');
                    }
                    that.initTags(true, true);
                }
                $('#add-tag-input').val('');
                that._unlock();
            }
        });
    }

    deleteTag(tagId) {
        if (this.locked) return;
        var that = this;
        this._lock();

        $.ajax({
            url: "/profile/set-tag/", dataType: 'json', type: 'post',
            data: {id: tagId, status: 0},
            success: function(data) {
                if (data.success != undefined && data.success) {
                    $("#tag-" + tagId).remove();
                    if (!$("li", "#tags").length) $("form", "#tags-wrapper").addClass("no-padding");

                    that.initTags(true, that.allTagsShown);
                }
                that._unlock();
            }
        });
    }

    initTags(reset, allShown) {
        var that = this;

        $('#tags').removeClass('transition').css('height', 'auto');
        $('#all-tags').removeClass('collapse').css('display', 'none').unbind('click');

        this.allTagsShown = true;

        if($('#tags').outerHeight() > 66) {
            this.allTagsShown = false;

            $('#tags').css('height', '44px');
            $('#all-tags').css('display', 'inline-block').bind('click', function() {
                (!that.allTagsShown) ? that.expandTags() : that.collapseTags();
                return false;
            });

            if (reset) {
                allShown ? this.expandTags(true) : this.collapseTags(true);
            }
        }
    }

    expandTags(noTransition) {
        var that = this;
        this.allTagsShown = true;

        this.tagsHeight = $('li:last', '#tags').position().top;
        $('#all-tags').addClass('collapse');

        (noTransition) ? $('#tags').removeClass('transition') : $('#tags').addClass('transition');
        $('#tags').css('height', 'auto');

        window.setTimeout(function() {
            that.updateMinimumHeight();
        }, noTransition ? 0 : 110);
    }

    collapseTags(noTransition) {
        var that = this;
        this.allTagsShown = false;

        $('#all-tags').removeClass('collapse');
        (noTransition) ? $('#tags').removeClass('transition') : $('#tags').addClass('transition');
        $('#tags').css('height', '44px');

        window.setTimeout(function() {
            that.updateMinimumHeight();
        }, noTransition ? 0 : 110);
    }

    loadEvents(callback) {
        if (this.allEventsLoaded) return;
        var that = this;

        $.ajax({
            url: "/profile/m/" + this.userId + "/events/", dataType: 'json', type: 'post',
            data: {offset: $("#events-list li").length},
            success: function(data) {
                if (data && data.success != undefined && data.success) {
                    if (data.events) {
                        $("#events-list").append(data.events);
                    } else {
                        that.allEventsLoaded = true;
                    }
                    if (callback) callback();
                }
            }
        });
    }

    eventsScrollHandler(e) {
        var that = e.data.profile;

        if ($(window).scrollTop() >= $(document).height() - $(window).height() - 100) {
            $(window).unbind("scroll", that.eventsScrollHandler);

            that.loadEvents(function() {
                that.updateMinimumHeight();
                $(window).bind("scroll", {profile: that}, that.eventsScrollHandler);
            });
        }
    }

    toggleEvents() {
        if (this.locked) return;

        if (!this.profileEventsOpened) {
            this.showEvents();
        } else {
            this.hideEvents();
        }
    }

    showEvents() {
        if (this.locked) return;

        this._lock();
        var that = this;

        $('html, body').animate({scrollTop : 0}, {duration : 50, queue : false});

        $('section.interests').fadeOut(500);
        $('section.gained-achievements').fadeOut(500);
        $('section.activities').fadeOut(500);

        window.setTimeout(function () {
            $('#all-events').html('« ' + that.texts.backBtn);
            that.loadEvents(function() {
                that._unlock();
                that.updateMinimumHeight();
            });
            $(window).bind("scroll", {profile: that}, that.eventsScrollHandler);
        }, 500);

        this.profileEventsOpened = true;
    }

    hideEvents() {
        if (this.locked) return;

        this.allEventsLoaded = false;
        this.profileEventsOpened = false;

        var i = 0;
        $("#events-list li").each(function() {
            i ++;
            if (i > 3) $(this).remove();
        });

        $('#all-events').html(this.texts.showInteractions);
        $('section.interests').fadeIn(0);
        $('section.gained-achievements').fadeIn(0);
        $('section.activities').fadeIn(0);

        this.updateMinimumHeight();

        $(window).unbind("scroll", this.eventsScrollHandler);
    }

    loadHosts(callback) {
        if (this.allHostsLoaded) return;
        var that = this;

        $.ajax({
            url: "/profile/m/" + this.userId + "/hosts/", dataType: 'json', type: 'post',
            data: {offset: $("#hosts-list li").length},
            success: function(data) {
                if (data && data.success != undefined && data.success) {
                    if (data.hosts) {
                        $("#hosts-list").append(data.hosts);
                        $("#hosts-list").append($("#hosts-list br").detach());
                    } else {
                        that.allHostsLoaded = true;
                    }
                    if (callback) callback();
                }
            }
        });
    }

    hostsScrollHandler(e) {
        var that = e.data.profile;

        if ($(window).scrollTop() >= $(document).height() - $(window).height() - 100) {
            $(window).unbind("scroll", that.hostsScrollHandler);

            that.loadHosts(function() {
                that.updateMinimumHeight();
                $(window).bind("scroll", {profile: that}, that.hostsScrollHandler);
            });
        }
    }

    toggleHosts() {
        if (this.locked) return;

        if (!this.profileHostsOpened) {
            this.showHosts();
        } else {
            this.hideHosts();
        }
    }

    showHosts() {
        if (this.locked) return;

        this._lock();
        var that = this;
        var delay = 0;

        if($(window).scrollTop() > 0) {
            delay = 500;
            $('html, body').animate({scrollTop : 0}, {duration : 400, queue : false});
        }

        window.setTimeout(function() {
            $('#all-hosts').html('« ' + that.texts.backBtn);
            $('ul.items-list').addClass('no-border');
            $('section.events').animate({height: 'toggle', opacity: 'toggle'}, {duration: 400, queue: false});
            $('#categories-wrapper').addClass('hide');
            $('#tags-wrapper').addClass('hide');
            $('section.gained-achievements').animate({height: 'toggle', opacity: 'toggle'}, {duration: 400, queue: false});
            $('section.activities').animate({height: 'toggle', opacity: 'toggle'}, {duration: 400, queue: false});

            window.setTimeout(function() {
                that.loadHosts(function() {
                    that._unlock();
                    that.updateMinimumHeight();
                });

                $(window).bind("scroll", {profile: that}, that.hostsScrollHandler);
            }, 400);
        }, delay);

        this.profileHostsOpened = true;
    }

    hideHosts() {
        if (this.locked) return;

        this.allHostsLoaded = false;
        this.profileHostsOpened = false;

        var i = 0;
        $("#hosts-list li").each(function() {
            i ++;
            if (i > 5) $(this).remove();
        });

        $('#all-hosts').html(this.texts.showHosts);
        $('ul.items-list').removeClass('no-border');
        $('section.events').animate({height: 'toggle', opacity: 'toggle'}, {duration: 0, queue: false});
        $('#categories-wrapper').removeClass('hide');
        $('#tags-wrapper').removeClass('hide');
        $('section.gained-achievements').animate({height: 'toggle', opacity: 'toggle'}, {duration: 0, queue: false});
        $('section.activities').animate({height: 'toggle', opacity: 'toggle'}, {duration: 0, queue: false});

        this.updateMinimumHeight();

        $(window).unbind("scroll", this.hostsScrollHandler);
    }

    loadAchievements(callback) {
        if (this.allAchievementsLoaded) return;
        var that = this;

        $.ajax({
            url: "/profile/m/" + this.userId + "/achievements/", dataType: 'json', type: 'post',
            data: {offset: $("#achievements-list li").length},
            success: function(data) {
                if (data && data.success != undefined && data.success) {
                    if (data.achievements) {
                        $("#achievements-list").append(data.achievements);
                    } else {
                        that.allAchievementsLoaded = true;
                    }
                    if (callback) callback();
                }
            }
        });
    }

    toggleAchievements() {
        if (this.locked) return;

        if (!this.profileAchievementsOpened) {
            this.showAchievements();
        } else {
            this.hideAchievements();
        }
    }

    showAchievements() {
        if (this.locked) return;

        this._lock();
        var that = this;
        var delay = 0;

        if($(window).scrollTop() > 0) {
            delay = 500;
            $('html, body').animate({scrollTop : 0}, {duration : 400, queue : false});
        }

        window.setTimeout(function() {
            $('#all-achievements').html('« ' + that.texts.backBtn);
            $('section.events').animate({height: 'toggle', opacity: 'toggle'}, {duration: 400, queue: false});
            $('section.interests').animate({height: 'toggle', opacity: 'toggle'}, {duration: 400, queue: false});
            $('section.activities').animate({height: 'toggle', opacity: 'toggle'}, {duration: 400, queue: false});

             window.setTimeout(function() {
                 that.loadAchievements(function() {
                     that._unlock();
                     that.updateMinimumHeight();
                 });
             }, 400);
        }, delay);

        this.profileAchievementsOpened = true;
    }

    hideAchievements() {
        if (this.locked) return;

        this.allAchievementsLoaded = false;
        this.profileAchievementsOpened = false;

        var i = 0;
        $("#achievements-list li").each(function() {
            i ++;
            if (i > 5) $(this).remove();
        });

        $('#all-achievements').html(this.texts.showAchievements);
        $('section.events').animate({height: 'toggle', opacity: 'toggle'}, {duration: 0, queue: false});
        $('section.interests').animate({height: 'toggle', opacity: 'toggle'}, {duration: 0, queue: false});
        $('section.activities').animate({height: 'toggle', opacity: 'toggle'}, {duration: 0, queue: false});

        this.updateMinimumHeight();
    }

    openActivity(url, btn) {
        if (this.locked || $(btn).hasClass('active')) return;

        var delay = 0;
        var that = this;
        this._lock();

        if($(window).scrollTop() != $('section.activities').offset().top - 90) {
            delay = 250;
            $('html, body').animate({ scrollTop: $('section.activities').offset().top - 90 }, { duration: 250, queue: false });
        }

        $.ajax({
            url: url, dataType: 'json', type: 'post',
            data: {},
            success: function(data) {
                window.setTimeout(function() {
                    if (data && data.success != undefined && data.success) {
                        $("#activity-content").html(data.activity);
                        $("#activity-calendar a").removeClass("active");
                        $(btn).addClass("active");
                        that._unlock();
                    } else {
                        that._unlock();
                    }

                    that.updateMinimumHeight();
                }, delay);
            }, error: function(e){
                console.log(e);
            }
        });
    }

    initProfile() {
        var that = this;

        this.minHeight = false;
        this.panelBox = $('section.panel');

        this.activities = false;
        this.activitiesBox = null;
        this.activitiesMonths = null;
        this.activitiesMonthsHeight = 0;

        if($('section.activities')[0])
        {
            this.activities = true;
            this.activitiesBox = $('section.activities');
            this.activitiesMonths = $('aside', this.activitiesBox);
            this.activitiesMonthsHeight = this.activitiesMonths.outerHeight();
            this.activitiesBox.css('minHeight', this.activitiesMonthsHeight);
        }

        $(window).resize(function() {
            that.stickyBoxesResizeHandler();
        });

        this.stickyBoxesResizeHandler();

        $(window).scroll(function() {
            that.stickyBoxesScrollHandler();
        });
        // remove picture
        $('section.panel a.remove').on('click',(e) => {
            e.preventDefault();
            that._removePicture();
        });

        // categories
        initCustomCheckboxes($('section.interests'));

        // buttons
        $('#all-events').click(function(e) {
            e.preventDefault();
            that.toggleEvents();
        });
        $('#all-hosts').click(function(e) {
            e.preventDefault();
            that.toggleHosts();
        });
        $('#all-achievements').click(function(e) {
            e.preventDefault();
            that.toggleAchievements();
        });

        // tags
        this.initTags();

        // activity calendar
        $("#activity-calendar a").click(function(e) {
            e.preventDefault();
            that.openActivity($(this).attr('href'), this);
        });

        // minimum height
        this.updateMinimumHeight();
    }

    initEditables() {
        var that = this;

        if (!that.mine)
            return;

        // name
        $('#profile_name').editable('/profile/save-single/?user=' + that.userId + '&lastNameOnly=' + that.lastNameOnly, {
            cssclass    : 'jeditable profile-name',
            type        : 'text',
            loadtext    : that.texts.saving,
            placeholder : that.texts.clickToEdit,
            onblur      : 'submit',
            data: function(value, settings) {
                var retval;
                if (value == that.texts.unnamedProfile) {
                    retval = that.texts.profileName;
                } else {
                    retval = value;
                }
                return retval;
            },

            onsubmit   : function (settings, original) {
                if (original.revert == $('input',this).val()) {
                    original.reset();
                    return false;
                }
            },
            callback   : function(value, settings) {
                that.texts.profileName = value;
                if (value.length == 0) {
                    value = that.texts.unnamedProfile;
                    that.texts.profileName = ' ';
                }else if (value == -1) {
                    value = this.revert;
                }
                $('#profile_name').html(value);
            }
        });
    }

    stickyBoxesResizeHandler() {
        if ($('div.profile').length)
            this.offsetLeft = $('div.profile').offset().left;
        $(window).scroll();
    }

    stickyBoxesScrollHandler() {
        // if(window.mapOpened) return;

        // var that = this;

        // var scrollAvailable = $(document).height() > $(window).height();
        // var left = (this.offsetLeft) ? this.offsetLeft : -$(window).scrollLeft();
        // var top = $(window).scrollTop();

        // if(this.minHeight || (!this.minHeight && !scrollAvailable)) {
        //     $(this.panelBox).css({
        //         position: 'absolute',
        //         top: '40px',
        //         left: '0px',
        //         bottom: 'auto'
        //     });
        // } else {
        //     if(top <= 0) {
        //         $(this.panelBox).css({
        //             position: 'absolute',
        //             top: '40px',
        //             left: '0px',
        //             bottom: 'auto'
        //         });
        //     } else if(top > 0 && top < 20) {
        //         $(this.panelBox).css({
        //             position: 'fixed',
        //             top: 110 - top,
        //             left: left + 'px',
        //             bottom: 'auto'
        //         });
        //     } else if(top >= ($(that.panelBox).parent().height() - $(that.panelBox).height() + 20)) {
        //         $(this.panelBox).css({
        //             position: 'absolute',
        //             top: 'auto',
        //             left: '0px',
        //             bottom: '-20px'
        //         });
        //     } else {
        //         $(this.panelBox).css({
        //             position: 'fixed',
        //             top: '90px',
        //             left: left + 'px',
        //             bottom: 'auto'
        //         });
        //     }
        // }

        // if(this.activities && !this.profileEventsOpened && !this.profileHostsOpened && !this.profileAchievementsOpened) {
        //     var activitiesBoxOffsetTop = this.activitiesBox.offset().top - 70;

        //     if(top <= activitiesBoxOffsetTop) {
        //         this.activitiesMonths.css({
        //             position: 'absolute',
        //             bottom: 'auto',
        //             left: '605px',
        //             top: '0px'
        //         });
        //     } else if(top - activitiesBoxOffsetTop > (this.activitiesBox.outerHeight() - this.activitiesMonthsHeight)) {
        //         this.activitiesMonths.css({
        //             position: 'absolute',
        //             bottom: '0px',
        //             left: '605px',
        //             top: 'auto'
        //         });
        //     } else {
        //         this.activitiesMonths.css({
        //             position: 'fixed',
        //             bottom: 'auto',
        //             left: (left + 855) + 'px',
        //             top: '70px'
        //         });
        //     }
        // }
    }

    updateMinimumHeight() {
        // var target = $('div.profile');
        // var panel = $('section.panel', target);

        // target.css('minHeight', '0px');
        // this.minHeight = false;

        // if(panel.height() >= target.height()) {
        //     target.css('minHeight', panel.height());
        //     this.minHeight = true;
        // }

        // this.stickyBoxesScrollHandler();
    }

    set(profileId) {
        if(profileId) {
            this.isLogged = true;
            this.profileId = profileId;
        }
        else {
            this.isLogged = false;
            this.profileId = 0;
        }
    }

    requestLogin() {
        if(!this.isLogged) {
            evedo.openLogin();
        }
    }

    requestRegistration() {
        if(!this.isLogged) {
            evedo.openRegistration();
        }
    }

    changeLanguage(callback) {
        if(window.activeModalInstance) {
            return;
        }

        if(!this.changeLanguageModal) {
            this.changeLanguageModal = new ModalTemplate('change-language-modal', { keyboard: false });
        }

        window.activeModalInstance = new ChangeLanguageModal(this.changeLanguageModal, callback);
    }

    // CATEGORIES:

    // setCategory(id, status, callback) {
    //     if(!this.isLogged) {
    //         return;
    //     }
    // },

    setCategories(ids, callback) {
        if(!this.isLogged) {
            return;
        }

        new DataSender({
            data: { ids: ids },
            url: '/profile/set-categories/',

            success: function(data) {
                if(callback) {
                    callback(data);
                }
            }
        });
    }

    // EVENTS:

    acceptCopromoteInvite(inviteId, callback) {
        if(!this.isLogged) {
            return;
        }

        new DataSender({
            data: { id: inviteId },
            url: '/event/accept-cohost-invite/',

            success: function(data) {
                if(data) {
                    if(callback) {
                        callback(data);
                    }
                }
            }
        });
    }

    // acceptCopromoteRequest: function(requestId, callback) {
    //     if(!this.isLogged) {
    //         return;
    //     }
    // },

    declineCopromoteInvite(inviteId, callback) {
        if(!this.isLogged) {
            return;
        }

        new DataSender({
            data: { id: inviteId },
            url: '/event/decline-cohost-invite/',

            success: function(data) {
                if(data) {
                    if(callback) {
                        callback(data);
                    }
                }
            }
        });
    }

    // declineCopromoteRequest: function(requestId, callback) {
    //     if(!this.isLogged) {
    //         return;
    //     }
    // },

    buyTickets(eventId, callback, options) {
        if (window.evedo != undefined && window.evedo.mobileDevice()) {
            window.open('/event/tickets/mobile/?id=' + eventId, '_blank');
        }
        else {
            if(window.activeModalInstance) {
                return;
            }

            if(!this.buyTicketsModal) {
                this.buyTicketsModal = new ModalTemplate('buy-tickets-modal', { keyboard: false });
            }

            window.activeModalInstance = new BuyTicketsModal(this.buyTicketsModal, eventId, callback, options);
        }
    }

    embedTickets(eventId) {
        if(window.activeModalInstance || !this.isLogged) {
            return;
        }

        if(!this.embedTicketsModal) {
            this.embedTicketsModal = new ModalTemplate('embed-tickets-modal', { keyboard: false });
        }

        window.activeModalInstance = new EmbedTicketsModal(this.embedTicketsModal, eventId);
    }

    manageDiscountCodes(eventId) {
        if(window.activeModalInstance) {
            return;
        }

        if(!this.discountCodesModal) {
            this.discountCodesModal = new ModalTemplate('manage-discount-codes-modal', { keyboard: false });
        }

        window.activeModalInstance = new ManageDiscountCodesModal(this.discountCodesModal, eventId);
    }

    openBillingInformation(eventId, callback) {
        if(window.activeModalInstance || !this.isLogged) {
            return;
        }

        if(!this.billingInformationModal) {
            this.billingInformationModal = new ModalTemplate('billing-information-modal', { keyboard: false });
        }

        window.activeModalInstance = new BillingInformationModal(this.billingInformationModal, eventId, callback);
    }

    importEvent() {
        if(!this.isLogged) {
            return;
        }

        var that = this;

        if(!this.importEventModal) {
            this.importEventModal = new ModalTemplate('import-event-modal');

            new DataLoader({
                url: '/event/import/load/',

                success: function(data) {
                    if(data.html) {
                        window.importEventModalInstance = new ImportEventModal(that.importEventModal, data.html);
                        window.importEventModalInstance.reset();
                        that.importEventModal.show();
                    }
                }
            });
        }
        else {
            window.importEventModalInstance.reset();
            this.importEventModal.show();
        }
    }

    rsvp(eventId, status, highlight, callback) {
        if(!this.isLogged) {
            this.requestLogin();
            return;
        }

        new DataSender({
            data: {
                id: eventId,
                status: status
            },
            url: '/event/change-rsvp/',

            success: function(data) {
                if(data.success) {
                    if(callback) {
                        callback(data);
                    }

                    if(status == 1) {
                        new DataSender({
                            data: { id: eventId },
                            url: '/event/change-rsvp-facebook/'
                        });

                        new DataSender({
                            data: { id: eventId },
                            url: '/event/change-rsvp-twitter/'
                        });
                    }

                    if(highlight) {
                        window.evedo.highlightRsvp(status);
                    }
                }
            }
        });
    }

    // FEATURE EVENT/PROMOTER:

    feature(type, id, callback) {
        if(window.activeModalInstance || !this.isLogged) {
            return;
        }

        if(!this.featureModal) {
            this.featureModal = new ModalTemplate('feature-modal', { keyboard: false });
        }

        window.activeModalInstance = new FeatureModal(this.featureModal, (type == 'promoter') ? 'promoter' : 'event', id, callback);
    }

    featureEvent(id, callback) {
        this.feature('event', id, callback);
    }

    featurePromoter(id, callback) {
        this.feature('promoter', id, callback);
    }

    featuredReport(type, id) {
        if(window.activeModalInstance || !this.isLogged) {
            return;
        }

        if(!this.featuredReportModal) {
            this.featuredReportModal = new ModalTemplate('featured-report-modal', { keyboard: false });
        }

        window.activeModalInstance = new FeaturedCampaignsReportModal(this.featuredReportModal, (type == 'promoter') ? 'promoter' : 'event', id);
    }

    featuredEventReport(id) {
        this.featuredReport('event', id);
    }

    featuredPromoterReport(id) {
        this.featuredReport('promoter', id);
    }

    // FRIENDS:

    // friend: function(id, callback) {
    //     if(!this.isLogged) {
    //         this.requestLogin();
    //         return;
    //     }
    // },

    friendMultiple(ids, callback) {
        if(!this.isLogged) {
            return;
        }

        new DataSender({
            data: { ids: ids },
            url: '/profile/friend-multiple/',

            success: function(data) {
                if(callback) {
                    callback(data);
                }
            }
        });
    }

    // unfriend(id, callback) {
    //     if(!this.isLogged) {
    //         return;
    //     }
    // },

// LOCATION:

    setLocation(cityId, callback) {
        if(!this.isLogged) {
            return;
        }

        new DataSender({
            data: { id: cityId },
            url: '/profile/set-location/',

            success: function(data) {
                if(callback) {
                    callback(data);
                }
            }
        });
    }

// PROMOTERS:

    follow(promoterId, callback) {
        if(!this.isLogged) {
            this.requestLogin();
            return;
        }

        new DataSender({
            data: { id: promoterId },
            url: '/promoter-following-follow/',

            success: function(data) {
                if(data) {
                    if(callback) {
                        callback(data);
                    }

                    new DataSender({
                        data: { id: promoterId },
                        url: '/promoter/follow-facebook/'
                    });

                    new DataSender({
                        data: { id: promoterId },
                        url: '/promoter/follow-twitter/'
                    });
                }
            }
        });
    }

    unfollow(promoterId, callback) {
        if(!this.isLogged) {
            this.requestLogin();
            return;
        }

        new DataSender({
            data: { id: promoterId },
            url: '/promoter-following-unfollow/',

            success: function(data) {
                if(data) {
                    if(callback) {
                        callback(data);
                    }
                }
            }
        });
    }

// SHARE EVENT/PROMTOER:

    share(type, id, callback) {
        if(window.activeModalInstance) {
            return;
        }

        if(!this.isLogged) {
            this.requestLogin();
            return;
        }

        var that = this;
        type = (type == 'event') ? 'event' : 'promoter';

        if(!this.shareModal) {
            this.shareModal = new ModalTemplate('share-modal');

            this.shareModal.on('show', function() {
                window.activeModalInstance = true;
            });

            this.shareModal.on('hide', function() {
                window.activeModalInstance = null;
            });
        }

        this.shareModal.html('<div class="loader"><i class="fas fa-circle-notch fa-spin"></i></div>');
        this.shareModal.show();

        new DataSender({
            data: { id: id },
            url: '/' + type + '/share/load/',

            success: function(data) {
                if(data.status) {
                    window.activeModalInstance = new ShareModal(that.shareModal, {
                        type: type,
                        id: id,
                        html: data.html,
                        moreFriends: data.more,
                        callback: (callback) ? callback : null
                    });
                }
            },

            error: function() {
                that.shareModal.hide();
            }
        });
    }

    shareEvent(id, callback) {
        this.share('event', id, callback);
    }

    sharePromoter(id, callback) {
        this.share('promoter', id, callback);
    }

// TAGS:

    // setTag: function(id, status, callback) {
    //     if(!this.isLogged) {
    //         return;
    //     }
    // }

    setTags(tags, status, callback) {
        if(!this.isLogged) {
            return;
        }

        if(tags.length) {
            new DataSender({
                data: { ids: tags, status: status },
                url: '/profile/set-tags/',

                success: function(data) {
                    if(callback) {
                        callback(data);
                    }
                }
            });
        }
    }
}

export { Profile }
